import request from '@utils/request'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  async settingStore({
    commit
  }, query) {
    await request.post('/admin/deposit/setting/store', query)
   
  },
  async fetchList({
    commit
  }, query) {
    const {
      items,
      pagination
    } = await request.post('/admin/merchant/member/level/search', query)
    return {
      items,
      total: pagination?.total || 1
    }
  },
  async store({
    commit
  }, query) {
    let data = {
      ...query
    }
    // data.startDate='fwsgewga'
    await request.post('/admin/merchant/member/level/store', data)

    // const resault = await request.post('/admin/deposit/store',data)
    // console.log(resault)
    // return resault
  },

  // 會員升等
  async memberStore({
    commit
  }, {memberId, ...query}) {
    let data = {
      ...query
    }
    await request.post(`/admin/merchant/member/${memberId}/changeLevel`, data)

  },
  async fetchSingle({
    commit
  }, id) {
    const {
      items
    } = await request.get(`/admin/merchant/member/level/${id}`)
    return items
  },
  async updateState({
    commit
  }, submitData) {
    await request.post('/admin/merchant/member/level/state', submitData)
  },
  // 排序
  async ordering({ commit }, { submitData }) {
    await request.post(`/admin/merchant/member/level/ordering`, submitData)
  },
}